import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import * as yup from "yup";
import { userRegisterAction } from "redux/actions/auth/registerAction";
import { useNavigate } from "react-router-dom";
import { LOGIN_PATH } from "Routes/paths";
import { useTranslation } from "react-i18next";

interface registerTypes {
  country: string;
  city: string;
  title: string;
  fullName: string;
  countryCode: string;
  phone: string;
  email: string;
  password: string;
}

const useRegisterFormik = (country: string) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      country: "",
      city: "",
      title: "",
      fullName: "",
      countryCode: "",
      phone: "",
      email: "",
      password: "",
    },

    validationSchema: yup.object({
      country: yup.string(),
      // .required(`${t("This field is required")}`)
      city: yup.string(),
      // .required(`${t("This field is required")}`)
      title: yup.string(),
      // .required(`${t("This field is required")}`)
      fullName: yup.string().required(`${t("This field is required")}`),
      phone:
        country === "eg"
          ? yup
              .string()
              .matches(
                /^(?:\+20|0)?(10|11|12|15)\d{8}$/,
                `${t("Invalid phone number")}`
              )
              .required(`${t("This field is required")}`)
          : country === "uae"
          ? yup
              .string()
              .matches(
                /^(?:\+971|0)?(50|55|56|52|58)\d{7}$/,
                `${t("Invalid phone number")}`
              )
              .required(`${t("This field is required")}`)
          : yup.string().required(`${t("This field is required")}`),
      email: yup
        .string()
        .email(`${t("email must be a valid email")}`)
        .required(`${t("This field is required")}`),
      password: yup
        .string()
        .min(8, `${t("password must be at least 8 characters long")}`)
        .matches(
          new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/),
          `${t("must contain lowercase, uppercase letter, one number")}`
        )
        .required(`${t("This field is required")}`),
    }),

    onSubmit: async (values: registerTypes) => {
      await dispatch(
        userRegisterAction(
          {
            email_id: values.email,
            title_id: values.title,
            full_name: values.fullName,
            country_code: values.countryCode,
            phone_number: values.phone,
            city_id: values.city,
            country_id: values.country,
            password: values.password,
            default_lang: `${i18n.language}`,
            social_media_name: "own",
            device: "web",
          },
          () => {
            setTimeout(() => {
              navigate(`${LOGIN_PATH}`);
            }, 2000);
          }
        )
      );
    },
  });

  return formik;
};

export { useRegisterFormik };
